import { useQuery } from 'react-query';
import { changeControlApi } from '../api/changeControl';
import { ChangeControlTemplateDTO } from '../types/DocumentCreate';

export const useCCTemplate = (
  templateId: number | undefined,
  enabled = false,
): {
  ccTemplate: ChangeControlTemplateDTO | undefined;
  isLoading: boolean;
} => {
  const { data: ccTemplate, isLoading } = useQuery<ChangeControlTemplateDTO>({
    queryKey: ['ccTemplate', templateId],
    queryFn: () => changeControlApi.fetchChangeControlTemplate(templateId!),
    enabled: enabled && !!templateId,
    refetchOnWindowFocus: false,
  });

  return { ccTemplate, isLoading };
};
